const countryMap = new Map<string, string>([
  ["Canada", "CA"],
  ["United States", "US"],
  ["Austria", "AT"],
  ["France", "FR"],
  ["Germany", "DE"],
  ["Italy", "IT"],
  ["Netherlands", "NL"],
  ["Poland", "PL"],
  ["Spain", "ES"],
  ["United Kingdom", "GB"],
  ["Japan", "JP"],
  ["Argentina", "AR"],
  ["Israel", "IL"],
]);

function getCountryCodeMap(
  countryMap: Map<string, string>
): Map<string, string> {
  const countryCodeMap = new Map<string, string>();
  countryMap.forEach((value, key) => {
    countryCodeMap.set(value, key);
  });
  return countryCodeMap;
}

const countryCodeMap = getCountryCodeMap(countryMap);

export const countries = Array.from(countryMap.keys());

export function toCountryCode(country: string) {
  return countryMap.get(country) ?? "US";
}

export function toCountry(countryCode: string) {
  return countryCodeMap.get(countryCode) ?? "United States";
}
